/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Open_EditorInputs */

const cs_templates_open_editor = /** @type {(inputs: Templates_Open_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít editor`)
};

const en_templates_open_editor = /** @type {(inputs: Templates_Open_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open editor`)
};

/**
* | output |
* | --- |
* | "Open editor" |
*
* @param {Templates_Open_EditorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_open_editor = /** @type {((inputs?: Templates_Open_EditorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Open_EditorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_open_editor(inputs)
	return cs_templates_open_editor(inputs)
});